
import React from 'react'
import { Typography } from '../../design_system/StyledComponents/components/Typography'
import { Button } from '../../design_system/StyledComponents/components/Button'
import { useDispatch, useSelector } from 'react-redux';
import { setShowUpgradePopup } from '../../Actions/ApplicationStateAction';

const UpgradeComponent = () => {
    const dispatch = useDispatch();
    const {designStep} = useSelector(state => state.ApplicationState);

    const handleClick = () => {
        dispatch(setShowUpgradePopup(true))
    }


  return (
    <div className={'upgrade-container' + (designStep === 3 ? ' design-step-3' : '')}>
      <Typography modifiers={["subtitle2"]}>Not able to draw?</Typography>
      <Button onClick={handleClick} style={{backgroundColor:"#E1544E", fontWeight: "700", fontSize:"17px"}} modifiers={[ "block"]}>Hire a pro for ₹999</Button>
    </div>
  )
}

export default UpgradeComponent
